export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Audible/theme/components/scorecard/MetricsLabels/index.js